import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import { Toaster } from "./components/ui/sonner";
import axios from "axios";
import "./App.css";
import LandingPage from "./LandingPage";
import AuthPage from "./AuthPage";
import PaymentSuccess from "./PaymentSuccess";
import ToolPage from "./ToolPage";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfUse from "./TermsOfUse";
import MarketingPage from "./pages/admin/marketing/MarketingPage";
import BlogArticle from "./pages/BlogArticle";
import BlogIndex from "./pages/BlogIndex";

import { API } from "./apiConfig";

// Global axios interceptor: auto-refresh expired access tokens
let isRefreshing = false;
let pendingQueue = [];

axios.interceptors.response.use(
  (res) => res,
  async (err) => {
    const orig = err.config;

    // Never intercept the refresh call itself — prevents deadlock
    if (orig.url?.includes("/auth/refresh")) {
      return Promise.reject(err);
    }

    if (err.response?.status === 401 && !orig._retry) {
      orig._retry = true;
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
          pendingQueue.forEach(({ resolve }) => resolve());
          pendingQueue = [];
          return axios(orig);
        } catch (refreshErr) {
          pendingQueue.forEach(({ reject }) => reject(refreshErr));
          pendingQueue = [];
          return Promise.reject(err);
        } finally {
          isRefreshing = false;
        }
      }
      return new Promise((resolve, reject) => {
        pendingQueue.push({ resolve, reject });
      }).then(() => axios(orig)).catch(() => Promise.reject(err));
    }
    return Promise.reject(err);
  }
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/tool" element={<ToolPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/pricing" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/admin/marketing" element={<MarketingPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
